import {ModalOverlay} from '@components/ui/modal-atoms/ModalAtoms.tsx'
import {createPortal} from 'react-dom'
import {AuthUser} from '@/features/auth/types'
import {AccountModalProfile} from '@/features/account/components/account-modal-profile/AccountModalProfile'
import {AccountModalSidebar} from '@/features/account/components/account-modal-sidebar/AccountModalSidebar'
import {useAccountStore} from '@/features/account/store/useAccountStore'
import {StyledAccountModal, StyledAccountModalBody} from './style'
import {UserDetailsAvailability} from '@/pages/user-details-availability/UserDetailsAvailability'
import {useAuthStore} from '@/features/auth/store/store'
import {useShallow} from 'zustand/react/shallow'

interface AccountModalProps {
    user: AuthUser
    width: string
}

export const AccountModal = ({user, width}: AccountModalProps) => {
    const isAccountModalOpened = useAccountStore(state => state.setIsAccountModalOpened)
    const modalView = useAccountStore(state => state.modalView)
    const authUser = useAuthStore(useShallow(state => state.user))

    return createPortal(
        <>
            <ModalOverlay onClick={() => isAccountModalOpened(false)} />
            <StyledAccountModal width={width} role="dialog" aria-modal>
                <AccountModalSidebar />
                <StyledAccountModalBody>
                    {modalView == 'profile' ? (
                        <AccountModalProfile user={user} onClose={() => isAccountModalOpened(false)} />
                    ) : (
                        authUser?.id && <UserDetailsAvailability userId={authUser.id} />
                    )}
                </StyledAccountModalBody>
            </StyledAccountModal>
        </>,
        document.body
    )
}
